import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("internalCode"),
            field: 'internalCode',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("evaluationType"),
            field: 'typeString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'evaluatedCode',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("evaluatedFullNamePlural"),
            field: 'evaluatedName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations],
        config: {
            headerName: getLocalizedString("evaluatorFullNamePlural"),
            field: 'evaluatorName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("evaluationStatus"),
            field: 'status',
            filter: "agSetColumnFilter",
            cellRenderer: "PerformanceFormStatusRenderer",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("evaluationDate"),
            field: 'date',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("assessedPosition"),
            field: 'evaluatedPosition',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("yourCompetenceRating"),
            field: 'qSkills',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("calibratedCompetenciesRating"),
            field: 'qSkillsC',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("yourObjectiveRating"),
            field: 'qTargets',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("calibratedRatingObjectives"),
            field: 'qTargetsC',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluations],
        config: {
            headerName: getLocalizedString("yourPotentialRating"),
            field: 'qPotential',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluations],
        config: {
            headerName: getLocalizedString("calibratedPotentialRating"),
            field: 'qPotentialC',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("function"),
            field: 'function',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("fType"),
            field: 'functionaryType',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("management"),
            field: 'management',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("department"),
            field: 'department',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'costCenter',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluations, "performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: 'contractDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.performanceEvaluations],
        config: {
            headerName: getLocalizedString("evaluatorComments"),
            field: 'comments',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsCollaborator"],
        config: {
            headerName: getLocalizedString("comments"),
            field: 'comments',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("internalCode"),
            field: 'internalCode',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("evaluationType"),
            field: 'type',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("evaluationStatus"),
            field: 'status',
            filter: "agSetColumnFilter",
            cellRenderer: "PerformanceFormStatusRenderer",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("evaluatorFullName"),
            field: 'evaluatorName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("evaluatorPosition"),
            field: 'evaluatorPosition',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'evaluatedCode',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("evaluatedFullNamePlural"),
            field: 'evaluatedName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("evaluationDate"),
            field: 'evaluationDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("assessedPosition"),
            field: 'evaluatedPosition',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("function"),
            field: 'function',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("fType"),
            field: 'functionaryType',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("management"),
            field: 'management',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("department"),
            field: 'department',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'costCenter',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: 'contractDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ["performanceEvaluationsAnalytics"],
        config: {
            headerName: getLocalizedString("evaluatorComments"),
            field: 'comments',
            filter: "agTextColumnFilter",
        }
    },
]